module.exports = "<div class=\"app-version\">\r\n  <span translate>\r\n    Version\r\n  </span>\r\n\r\n  <span>\r\n    :\r\n  </span>\r\n\r\n  <span>\r\n    {{ $ctrl.frontendVersion }}\r\n  </span>\r\n\r\n  <span>\r\n    /\r\n  </span>\r\n\r\n  <span>\r\n    {{ $ctrl.backendVersion }}\r\n  </span>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-app-version/rw-app-version.html
// module id = 1934
// module chunks = 0